import get from 'lodash.get';
import { updateRowStatus } from '../../../components/webEntryPanel/utils';
import {
    SAVE_BASIC_COMPREHENSION_RESULT,
    INVALIDATE_BASIC_COMPREHENSION_RESULT,
    CLEAR_BASIC_COMPREHENSION_WEB_ENTRY_DATA,
    UPDATE_ROW_STATUS_OBJECT,
} from '../../actionTypes/shared/apiActionTypes';

export const initialState = {
    rowsStatuses: {},
    gradeDate: {},
    isPanelUpdating: false,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SAVE_BASIC_COMPREHENSION_RESULT.ERROR:
            return {
                ...state,
                isPanelUpdating: false,
                rowsStatuses: updateRowStatus(state.rowsStatuses, action.studentId, {
                    isRowSaving: false,
                    isRowDisabled: true,
                    isAlreadyCreated: false,
                }),
            };
        case SAVE_BASIC_COMPREHENSION_RESULT.SUCCESS:
            return {
                ...state,
                isPanelUpdating: false,
                rowsStatuses: updateRowStatus(
                    state.rowsStatuses,
                    action.additionalResponseParams.studentId,
                ),
            };
        case INVALIDATE_BASIC_COMPREHENSION_RESULT.START:
        case SAVE_BASIC_COMPREHENSION_RESULT.START:
            return {
                ...state,
                isPanelUpdating: true,
                rowsStatuses: updateRowStatus(state.rowsStatuses, action.studentId, {
                    isRowDisabled: true,
                    isRowSaving: false,
                }),
            };
        case INVALIDATE_BASIC_COMPREHENSION_RESULT.SUCCESS:
            return {
                ...state,
                isPanelUpdating: false,
                rowsStatuses: updateRowStatus(
                    state.rowsStatuses,
                    action.additionalResponseParams.studentId,
                    {
                        isRowDisabled: false,
                        isRowSaving: false,
                        isAlreadyCreated: false,
                    },
                ),
            };
        case UPDATE_ROW_STATUS_OBJECT:
            return {
                ...state,
                rowsStatuses: updateRowStatus(state.rowsStatuses, action.studentId, {
                    isRowDisabled: action.isRowDisabled,
                    isRowSaving: action.isRowSaving,
                    isAlreadyCreated: action.isAlreadyCreated,
                }),
            };
        case CLEAR_BASIC_COMPREHENSION_WEB_ENTRY_DATA:
            return initialState;
        default:
            return state;
    }
};

const getAllRowsStatuses = state => get(state, 'rowsStatuses', {});

const getAllStudentsDateForGrade = (state, grade) => get(state, `gradeDate[${grade}]`, {});

const isPanelUpdating = state => state.isPanelUpdating;

export const selectors = {
    getAllRowsStatuses,
    getAllStudentsDateForGrade,
    isPanelUpdating,
};
